var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mode7-wrap"},[_c('HTxtBanner',{directives:[{name:"exposure",rawName:"v-exposure",value:({ eid: `101_15_${_vm.curindex}_0` }),expression:"{ eid: `101_15_${curindex}_0` }"}],attrs:{"data-id":`101_15_${_vm.curindex}_0`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }